// =====================================================================
// SIMULATORE AI PRODIGY — ARCHETIPI (modificabili)
// L'archetipo dipende dalle 2 dimensioni con punteggio più alto.
// Sigle: L Leadership · P Problem Solving · A Adattabilità · R Precisione · C Comunicazione · V Creatività
// =====================================================================

// Coppia di dimensioni (sempre nell'ordine L, P, A, R, C, V) → archetipo. Tutte le 15 coppie sono coperte.
export const COPPIE = {
  LP: "stratega",
  LA: "navigatore",
  LR: "regista",
  LC: "catalizzatore",
  LV: "pioniere",
  PA: "esploratore",
  PR: "analista",
  PC: "mediatore",
  PV: "visionario",
  AR: "custode",
  AC: "mediatore",
  AV: "esploratore",
  RC: "custode",
  RV: "architetto",
  CV: "innovatore",
};

// "dimensioni" = le 2 dimensioni dominanti mostrate nella Galleria Archetipi.
// Testo narrativo: {prima}, {seconda} e {ultima} vengono sostituiti con i nomi delle dimensioni.
export const NARRATIVA = {
  apertura: "Nelle situazioni proposte la dimensione dominante è {prima}, sostenuta da una solida componente di {seconda}.",
  chiusura: "La dimensione meno espressa, {ultima}, non è un limite: è lo spazio in cui puoi crescere più rapidamente.",
};

export const ARCHETIPI = {
  stratega: {
    nome: "Lo Stratega",
    dimensioni: ["L", "P"],
    titolo: "Visione d'insieme e decisioni che portano risultati",
    descrizione: "guida le persone con un piano chiaro e soluzioni ragionate.",
    racconto: "Tendi a guardare il quadro generale, a individuare la strada più efficace e a coinvolgere gli altri per percorrerla. Quando la situazione si complica, sei tu a trasformare l'incertezza in un piano.",
    forza: ["Visione d'insieme e definizione delle priorità", "Decisioni rapide ma ragionate", "Capacità di tradurre gli obiettivi in piani concreti", "Autorevolezza nei momenti critici"],
    sviluppo: ["Puoi lasciare più spazio alle idee degli altri prima di decidere.", "Puoi affidare con fiducia i dettagli operativi a chi lavora con te."],
    contesti: ["Coordinamento di progetti", "Ruoli di pianificazione", "Gestione di team"],
    team: "È il punto di riferimento quando serve una direzione: definisce gli obiettivi, fissa le priorità e tiene il gruppo concentrato sul risultato.",
  },
  navigatore: {
    nome: "Il Navigatore",
    dimensioni: ["L", "A"],
    titolo: "Leadership che sa cambiare rotta senza perdere la meta",
    descrizione: "guida il gruppo anche quando lo scenario cambia all'improvviso.",
    racconto: "Ti muovi bene nei contesti incerti: sai prendere l'iniziativa e, allo stesso tempo, correggere la direzione quando le condizioni cambiano. Gli altri ti seguono perché trasmetti calma e movimento insieme.",
    forza: ["Sangue freddo negli imprevisti", "Capacità di guidare il cambiamento", "Rapidità nel riorganizzare persone e attività", "Energia contagiosa nei momenti di transizione"],
    sviluppo: ["Puoi consolidare i risultati raggiunti prima di passare alla sfida successiva.", "Puoi affiancare alla flessibilità alcuni punti fermi condivisi con il gruppo."],
    contesti: ["Progetti in rapida evoluzione", "Avvio di nuove attività", "Coordinamento operativo"],
    team: "Tiene unito il gruppo quando i piani saltano: riorganizza in fretta, rassicura e indica la prossima mossa.",
  },
  regista: {
    nome: "Il Regista",
    dimensioni: ["L", "R"],
    titolo: "Ordine, metodo e una guida sicura dall'inizio alla fine",
    descrizione: "coordina ogni elemento perché il risultato finale sia impeccabile.",
    racconto: "Ami avere il quadro sotto controllo e sai orchestrare persone, tempi e risorse con precisione. Per te un buon risultato nasce da una regia attenta e da standard chiari per tutti.",
    forza: ["Organizzazione e gestione dei tempi", "Standard di qualità elevati e condivisi", "Affidabilità nel portare a termine gli impegni", "Capacità di coordinare molte attività insieme"],
    sviluppo: ["Puoi concederti più margine di improvvisazione quando il contesto lo richiede.", "Puoi delegare anche le attività che preferiresti seguire personalmente."],
    contesti: ["Gestione di eventi e produzioni", "Coordinamento operativo", "Controllo di progetti complessi"],
    team: "Garantisce che tutto arrivi in tempo e nel modo giusto: definisce ruoli, scadenze e verifiche, e fa in modo che nessun dettaglio si perda.",
  },
  catalizzatore: {
    nome: "Il Catalizzatore",
    dimensioni: ["L", "C"],
    titolo: "Energia che unisce le persone e le porta all'azione",
    descrizione: "trasforma un gruppo di individui in una squadra motivata.",
    racconto: "Sai coinvolgere, motivare e dare voce alle persone, e allo stesso tempo prendi l'iniziativa quando serve. Il tuo talento è far muovere gli altri nella stessa direzione.",
    forza: ["Capacità di motivare e coinvolgere", "Comunicazione chiara e convincente", "Iniziativa nei momenti di stallo", "Costruzione di fiducia nel gruppo"],
    sviluppo: ["Puoi dedicare più tempo all'analisi prima di lanciare un'iniziativa.", "Puoi trasformare l'entusiasmo del gruppo in abitudini stabili nel tempo."],
    contesti: ["Ruoli a contatto con le persone", "Coordinamento di gruppi", "Formazione e comunicazione"],
    team: "È il motore relazionale del gruppo: crea coesione, dà energia nei momenti difficili e fa sentire ognuno parte del progetto.",
  },
  pioniere: {
    nome: "Il Pioniere",
    dimensioni: ["L", "V"],
    titolo: "Idee nuove e il coraggio di guidarle per primo",
    descrizione: "apre strade inesplorate e convince gli altri a percorrerle.",
    racconto: "Ti attirano le sfide nuove e non hai paura di proporre soluzioni fuori dagli schemi, prendendotene la responsabilità. Dove altri vedono rischi, tu vedi territori da esplorare.",
    forza: ["Spirito d'iniziativa e intraprendenza", "Pensiero originale applicato all'azione", "Coraggio nel proporre il cambiamento", "Capacità di ispirare con una visione"],
    sviluppo: ["Puoi accompagnare le tue idee con verifiche più strutturate.", "Puoi coinvolgere prima gli altri per rafforzare il consenso sulle novità."],
    contesti: ["Nuovi progetti e startup", "Innovazione di prodotti o servizi", "Iniziative imprenditoriali"],
    team: "Porta il gruppo oltre la zona di comfort: lancia nuove idee, apre la strada e dà l'esempio quando bisogna osare.",
  },
  analista: {
    nome: "L'Analista",
    dimensioni: ["P", "R"],
    titolo: "Mente analitica che trasforma la complessità in decisioni",
    descrizione: "legge i dati con rigore e trova la risposta più solida.",
    racconto: "Affronti i problemi scomponendoli, verificando ogni passaggio e basando le scelte su elementi concreti. La tua forza è la lucidità: difficilmente ti lasci guidare dalle impressioni.",
    forza: ["Pensiero logico e strutturato", "Attenzione ai dati e ai dettagli", "Capacità di individuare errori e incoerenze", "Decisioni basate su elementi verificabili"],
    sviluppo: ["Puoi agire anche con informazioni incomplete quando il tempo stringe.", "Puoi condividere più spesso il tuo ragionamento per coinvolgere gli altri."],
    contesti: ["Analisi di dati e processi", "Ricerca e verifica", "Ruoli tecnici e di controllo"],
    team: "È la voce della lucidità: verifica le ipotesi, individua i punti deboli e aiuta il gruppo a decidere su basi solide.",
  },
  visionario: {
    nome: "Il Visionario Pragmatico",
    dimensioni: ["P", "V"],
    titolo: "Idee originali che funzionano davvero",
    descrizione: "unisce creatività e concretezza per risolvere problemi in modo nuovo.",
    racconto: "Sai immaginare soluzioni diverse dal solito, ma non perdi mai di vista la loro applicabilità. Per te una buona idea è quella che risolve un problema reale.",
    forza: ["Creatività orientata alla soluzione", "Capacità di vedere connessioni non ovvie", "Concretezza nel valutare le idee", "Rapidità nel trovare alternative"],
    sviluppo: ["Puoi dedicare più cura alla rifinitura dei dettagli finali.", "Puoi raccontare meglio le tue idee per renderle più facili da adottare."],
    contesti: ["Progettazione e sviluppo", "Miglioramento dei processi", "Ruoli di innovazione"],
    team: "Sblocca le situazioni ferme: propone soluzioni inattese ma realistiche e aiuta il gruppo a superare gli ostacoli con approcci nuovi.",
  },
  innovatore: {
    nome: "L'Innovatore",
    dimensioni: ["C", "V"],
    titolo: "Creatività che sa farsi ascoltare",
    descrizione: "genera idee nuove e le rende contagiose per chi lo circonda.",
    racconto: "Hai un talento naturale per immaginare il nuovo e per raccontarlo in modo coinvolgente. Le tue idee non restano nel cassetto: diventano conversazioni, progetti e cambiamenti.",
    forza: ["Generazione di idee originali", "Capacità di raccontare e coinvolgere", "Sensibilità verso persone e tendenze", "Apertura verso punti di vista diversi"],
    sviluppo: ["Puoi accompagnare le idee con un piano operativo più dettagliato.", "Puoi concentrare l'energia su meno progetti per portarli fino in fondo."],
    contesti: ["Comunicazione e contenuti", "Design e progettazione creativa", "Marketing e relazioni"],
    team: "Porta aria nuova nel gruppo: stimola il confronto, propone idee fresche e sa renderle convincenti anche per gli scettici.",
  },
  architetto: {
    nome: "L'Architetto",
    dimensioni: ["R", "V"],
    titolo: "Immaginazione con fondamenta solide",
    descrizione: "progetta soluzioni originali costruite con metodo e precisione.",
    racconto: "Unisci il gusto per le idee nuove alla cura per la struttura: immagini, poi costruisci con attenzione ogni dettaglio. Il risultato sono progetti originali e, allo stesso tempo, affidabili.",
    forza: ["Creatività strutturata e metodica", "Cura estetica e funzionale del risultato", "Precisione nella realizzazione", "Capacità di dare forma concreta alle idee"],
    sviluppo: ["Puoi condividere versioni intermedie per ottenere riscontri prima.", "Puoi coinvolgere gli altri già nelle prime fasi della progettazione."],
    contesti: ["Progettazione e design", "Sviluppo di prodotti", "Ruoli tecnico-creativi"],
    team: "Trasforma le idee del gruppo in progetti realizzabili: definisce la struttura, cura la qualità e dà forma a ciò che gli altri hanno solo immaginato.",
  },
  esploratore: {
    nome: "L'Esploratore",
    dimensioni: ["A", "V"],
    titolo: "Curiosità che trasforma l'ignoto in opportunità",
    descrizione: "si muove a suo agio nel nuovo e impara sperimentando.",
    racconto: "Ti trovi bene nelle situazioni nuove: provi, osservi, correggi e trovi strade che altri non avevano considerato. Il cambiamento, per te, è uno stimolo e non una minaccia.",
    forza: ["Curiosità e voglia di imparare", "Flessibilità di fronte al nuovo", "Capacità di sperimentare e correggere", "Apertura verso soluzioni alternative"],
    sviluppo: ["Puoi trasformare ciò che scopri in metodi da condividere con gli altri.", "Puoi darti obiettivi intermedi per tradurre le esplorazioni in risultati."],
    contesti: ["Ambienti dinamici e in evoluzione", "Ricerca e sviluppo", "Progetti multidisciplinari"],
    team: "È il primo a provare strade nuove: testa le idee, porta scoperte al gruppo e rende il cambiamento meno spaventoso per tutti.",
  },
  mediatore: {
    nome: "Il Mediatore",
    dimensioni: ["C", "A"],
    titolo: "Ascolto e ragionamento che trovano un punto d'incontro",
    descrizione: "costruisce ponti tra persone, idee ed esigenze diverse.",
    racconto: "Sai metterti nei panni degli altri e trovare soluzioni che tengano conto di punti di vista differenti. Nei momenti di tensione, la tua capacità di ascolto diventa una risorsa per tutto il gruppo.",
    forza: ["Ascolto attivo ed empatia", "Gestione dei conflitti", "Capacità di adattare il linguaggio all'interlocutore", "Ricerca di soluzioni condivise"],
    sviluppo: ["Puoi esprimere con più decisione la tua posizione quando serve.", "Puoi accettare che non ogni scelta debba mettere d'accordo tutti."],
    contesti: ["Ruoli a contatto con clienti o utenti", "Gestione delle relazioni", "Supporto e orientamento"],
    team: "È il collante del gruppo: facilita il dialogo, scioglie le tensioni e fa in modo che ogni voce venga ascoltata.",
  },
  custode: {
    nome: "Il Custode della Qualità",
    dimensioni: ["R", "A"],
    titolo: "Affidabilità che non si piega agli imprevisti",
    descrizione: "garantisce standard elevati anche quando tutto cambia.",
    racconto: "Per te la qualità non è negoziabile: verifichi, curi i dettagli e mantieni gli impegni anche quando le condizioni cambiano. Chi lavora con te sa di poter contare su risultati affidabili.",
    forza: ["Precisione e cura del dettaglio", "Affidabilità costante", "Standard mantenuti anche sotto pressione", "Chiarezza nel definire regole e procedure"],
    sviluppo: ["Puoi concederti più spazio per sperimentare soluzioni non ancora collaudate.", "Puoi accettare risultati \"abbastanza buoni\" quando la velocità conta di più."],
    contesti: ["Controllo qualità e verifica", "Gestione amministrativa e documentale", "Coordinamento dei processi"],
    team: "È la garanzia del gruppo: controlla che tutto sia corretto, mantiene l'ordine e assicura che il lavoro consegnato sia all'altezza.",
  },
};
